import type {
  ChannelCourseResource,
  ChannelExpandedCommon,
  ChannelProgramResource,
} from '../../../api/channel/types';
import type {FileApiModel} from '../../../api/media/file/types';

import {currentUserStore} from '../../../api/user';
import {not} from '../../conditionalUtils';
import {envManager} from '../../env';
import {isCourseCorporate} from '../course';
import {getSupportLogoFile} from '../file';
import {isUserHasRole} from '../user';

export const getChannelInfo = (channel: ChannelExpandedCommon) => {
  const info: {
    avatar?: FileApiModel | null;
    title: string;
  } = {
    avatar: null,
    title: '',
  };

  if (!channel || !channel._id) {
    return info;
  }

  if (channel.resource && channel.resource._id) {
    if (channel.type === 'program') {
      info.avatar = (channel.resource as ChannelProgramResource).avatar;
      info.title = (channel.resource as ChannelProgramResource).title;

      return info;
    } else if (
      channel.type === 'course' &&
      (channel.resource as ChannelCourseResource).program
    ) {
      info.avatar = (channel.resource as ChannelCourseResource).program!.avatar;
      info.title = (channel.resource as ChannelCourseResource).program!.title;
    }

    if (
      (channel.resource as ChannelCourseResource).edition &&
      (channel.resource as ChannelCourseResource).edition!.group_size === 1 &&
      currentUserStore.user &&
      channel.resource.coach_ids &&
      channel.resource.coach_ids.includes(currentUserStore.user._id) &&
      (channel.resource as ChannelCourseResource).client
    ) {
      const course = channel.resource as ChannelCourseResource;
      const {client} = course;
      const clientName = client!.name || 'Client not found';

      if (isCourseCorporate(course)) {
        info.title = clientName;

        const subtenant = course.subtenant;

        if (subtenant) {
          const subtenantTitle = subtenant.title;
          const notFoundTenantTitle = envManager.isCore
            ? 'Fake tenant'
            : 'Tenant not found';
          const tenantTitle = subtenant.tenant?.title || notFoundTenantTitle;

          info.title += ` (${subtenantTitle}/${tenantTitle})`;
        }
      } else {
        info.title += ` (${clientName})`;
      }
    }
  } else if (channel.members) {
    const members = channel.members.filter(
      member =>
        member &&
        member._id !==
          (currentUserStore.user ? currentUserStore.user._id : null),
    );

    info.title = members
      .map(member => member!.name || 'Member not found')
      .join(', ');
    info.avatar = members.length === 1 ? members[0]!.avatar : null;

    if (channel.type === 'support') {
      const client = channel.members.find(member =>
        not(isUserHasRole('support', member)),
      );

      info.title = [
        channel.title,
        isUserHasRole('support') && client ? ` (${client.name})` : null,
      ]
        .filter(Boolean)
        .join('');
      info.avatar = getSupportLogoFile(340);
    }
  }

  return info;
};
